export default {
  // 页面标题
  'finance.budgetRequest.headerTitle': '预算申请管理',

  // 表格列标题
  'finance.budgetRequest.column.code': '申请编号',
  'finance.budgetRequest.column.name': '申请名称',
  'finance.budgetRequest.column.billingPeriod': '账期',
  'finance.budgetRequest.column.amount': '申请金额',
  'finance.budgetRequest.column.status': '状态',
  'finance.budgetRequest.column.applyRemark': '申请说明',
  'finance.budgetRequest.column.remarks': '备注',

  // 状态标签
  'finance.budgetRequest.status.draft': '草稿',
  'finance.budgetRequest.status.pending': '待审批',
  'finance.budgetRequest.status.approved': '已通过',
  'finance.budgetRequest.status.rejected': '已拒绝',

  // 按钮操作
  'finance.budgetRequest.action.create': '新建预算申请',
  'finance.budgetRequest.action.submitAudit': '提交审核',
  'finance.budgetRequest.action.upload': '点击上传文件',

  // 确认对话框
  'finance.budgetRequest.confirm.delete': '确定要删除这个预算申请吗？',
  'finance.budgetRequest.confirm.batchDelete': '确定要批量删除选中的预算申请吗？',

  // 消息提示
  'finance.budgetRequest.message.getDetailFailed': '获取预算申请详情失败',
  'finance.budgetRequest.message.generateCodeFailed': '生成申请编号失败',
  'finance.budgetRequest.message.selectForAudit': '请选择要提交审核的预算申请',
  'finance.budgetRequest.message.submitAudit.success': '提交审核成功',
  'finance.budgetRequest.message.submitAudit.failed': '提交审核失败',
  'finance.budgetRequest.message.update.success': '更新预算申请成功',
  'finance.budgetRequest.message.update.failed': '更新预算申请失败',
  'finance.budgetRequest.message.create.success': '创建预算申请成功',
  'finance.budgetRequest.message.create.failed': '创建预算申请失败',

  // 详情标签
  'finance.budgetRequest.label.code': '申请编号',
  'finance.budgetRequest.label.name': '申请名称',
  'finance.budgetRequest.label.billingPeriod': '账期',
  'finance.budgetRequest.label.amount': '申请金额',
  'finance.budgetRequest.label.status': '状态',
  'finance.budgetRequest.label.applyRemark': '申请说明',
  'finance.budgetRequest.label.attachment': '附件文件',
  'finance.budgetRequest.label.remarks': '备注',

  // 表单字段标签
  'finance.budgetRequest.form.code.label': '申请编号',
  'finance.budgetRequest.form.code.placeholder': '请输入申请编号',
  'finance.budgetRequest.form.code.required': '请输入申请编号',
  'finance.budgetRequest.form.code.max': '申请编号长度不能超过100个字符',

  'finance.budgetRequest.form.name.label': '申请名称',
  'finance.budgetRequest.form.name.placeholder': '请输入申请名称',
  'finance.budgetRequest.form.name.required': '申请名称为必填项',
  'finance.budgetRequest.form.name.max': '申请名称长度不能超过100个字符',

  'finance.budgetRequest.form.billingPeriod.label': '账期',
  'finance.budgetRequest.form.billingPeriod.placeholder': '请选择账期',
  'finance.budgetRequest.form.billingPeriod.required': '账期为必填项',

  'finance.budgetRequest.form.amount.label': '申请金额',
  'finance.budgetRequest.form.amount.placeholder': '请输入申请金额',
  'finance.budgetRequest.form.amount.required': '请输入申请金额',
  'finance.budgetRequest.form.amount.min': '金额不能小于0',

  'finance.budgetRequest.form.applyRemark.label': '申请说明',
  'finance.budgetRequest.form.applyRemark.placeholder': '请输入申请说明',
  'finance.budgetRequest.form.applyRemark.max': '申请说明长度不能超过500个字符',

  'finance.budgetRequest.form.remarks.label': '备注',
  'finance.budgetRequest.form.remarks.placeholder': '请输入备注信息',
  'finance.budgetRequest.form.remarks.max': '备注长度不能超过500个字符',

  'finance.budgetRequest.form.bankStatement.label': '银行账单',
  'finance.budgetRequest.form.bankStatement.placeholder': '请搜索并选择银行账单',

  'finance.budgetRequest.form.auditName.label': '审核名称',
  'finance.budgetRequest.form.auditName.placeholder': '请输入审核名称',
  'finance.budgetRequest.form.auditName.required': '请输入审核名称',

  'finance.budgetRequest.form.submitRemark.label': '提交说明',
  'finance.budgetRequest.form.submitRemark.placeholder': '请输入提交说明（可选）',

  // 弹窗和抽屉标题
  'finance.budgetRequest.modal.detailTitle': '预算申请详情',
  'finance.budgetRequest.modal.submitAuditTitle': '提交审核',
  'finance.budgetRequest.drawer.title.create': '新增预算申请',
  'finance.budgetRequest.drawer.title.edit': '编辑预算申请',

  // 分区标题
  'finance.budgetRequest.section.basic': '基本信息',
  'finance.budgetRequest.section.apply': '申请信息',
  'finance.budgetRequest.section.attachment': '附件信息',
  'finance.budgetRequest.section.other': '其他信息',
  'finance.budgetRequest.section.auditRecords': '审核记录',
  'finance.budgetRequest.section.bankStatement': '关联银行账单',

  // 审核相关
  'finance.budgetRequest.audit.defaultName': '预算申请审核（{count}笔）',
  'finance.budgetRequest.selectedBills': '选中的预算申请列表（共 {count} 条）',
  'finance.budgetRequest.loading': '加载中...',
  'finance.budgetRequest.empty.auditRecords': '暂无审核记录',
  'finance.budgetRequest.message.bankStatementNotFound': '银行账单信息加载失败',

  // 操作相关
  'finance.budgetRequest.action.downloadOriginal': '下载原文件',
};
